export default "__VITE_ASSET__CdZMpNjD__"